import { render } from "./ConfirmMyAccountForm.vue?vue&type=template&id=7b0f0d41&ts=true"
import script from "./ConfirmMyAccountForm.vue?vue&type=script&lang=ts"
export * from "./ConfirmMyAccountForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__